import React, { useContext } from 'react'
import { SessionContext } from 'spa/App'
import { StyledTop } from './styled'
import { TopLayout } from '../../layouts/TopLayout'
import './Top.scss'
import { Head } from 'spa/config/Head'
import { SeoMemberTechCompanyName } from 'spa/member/constants/companyName'

const Index: React.FC = () => {
  const session = useContext(SessionContext)
  const title = `フリーランス求人・業務委託の案件情報が満載 - ${SeoMemberTechCompanyName}`
  const description = 'フリーランスで働きたい・独立して業務委託として働きたい人のための求人サイト「クラウドワークス テック」。報酬額や勤務地、職種やスキルなどあなたの希望を専属スタッフが伺い、最適なお仕事をご提案します。'

  if (session?.user) {
    location.href = '/dashboard'
    return null
  }

  return (
    <TopLayout>
      <Head title={title} description={description} />
      <StyledTop />
    </TopLayout>
  )
}

export default Index
